export default __webpack_public_path__ + "static/media/react.176085cf.ico";